module.exports = __webpack_public_path__ + "img/logo-voetreflextherapie.96d602f0.jpg";